import React, { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { getAllAddress } from "../../helpers/address";

const LocationProvider = ({ children }) => {
  const { watch, getValues, formState: { isDirty } } = useFormContext();
  const [provinces, setProvinces] = useState([]);
  const [wards, setWards] = useState([]);

  // =============Value selected=============
  const provinceWatch = watch("province");
  useEffect(() => {
    getAllAddress().then((data) => {
      setProvinces([...data].sort((a, b) => b.id === 79 ? 1 : -1));
      const { province: cP } = getValues();
      if (cP) {
        setWards(data.find(e => e.id === cP.value)?.Wards || []);
      }
    });
  }, []);

  // Provinces Dropdown Options
  const provinceOptions = useMemo(
    () =>
      provinces?.map((val) => ({
        label: val.name,
        value: val.id,
      }))?.sort((a, b) => (a.label > b.label ? 1 : -1)),
    [provinces]
  );

  // Wards Dropdown Options
  const wardOptions = useMemo(
    () =>
      wards?.map((val) => ({
        label: val.name,
        value: val.id,
      }))?.sort((a, b) => (a.label > b.label ? 1 : -1)),
    [wards]
  );

  // LISTENER OPTIONS CHANGE
  useEffect(() => {
    if (provinces.length > 0 && provinceWatch?.value) {
      const provinceFinded = provinces.find(e => e.id === provinceWatch?.value);
      setWards(provinceFinded?.Wards || []);
    }
  }, [provinceWatch, isDirty, provinces]);

  return (
    <>
      {children({
        provinceOptions,
        wardOptions,
      })}
    </>
  );
};
export default LocationProvider;
